<template>
    <div class="check-content-form">
        <!-- ① 关键词违规 -->
        <div class="ccf-card">
            <div class="ccf-card__head">
                <span class="ccf-badge">1</span>
                <span class="ccf-card__title">关键词违规</span>
            </div>
            <div class="ccf-card__body">
                <div class="ccf-row">
                    <el-checkbox v-model="form.skuNameAbnormalWords_check" />
                    <span class="ccf-text">检测：SKU名称包含</span>
                </div>
                <el-input class="ccf-textarea" type="textarea" :rows="3"
                    :disabled="!form.skuNameAbnormalWords_check" v-model="form.skuNameAbnormalWords"
                    placeholder="输入关键词" />
            </div>
        </div>

        <!-- ② 尺码违规 -->
        <div class="ccf-card">
            <div class="ccf-card__head">
                <span class="ccf-badge">2</span>
                <span class="ccf-card__title">尺码违规</span>
            </div>
            <div class="ccf-card__body">
                <div class="ccf-row">
                    <el-checkbox v-model="form.skuSizeAbnormalWords_check" />
                    <span class="ccf-text">检测：SKU尺码包含</span>
                </div>
                <el-input class="ccf-textarea" type="textarea" :rows="3"
                    :disabled="!form.skuSizeAbnormalWords_check" v-model="form.skuSizeAbnormalWords"
                    placeholder="输入尺码" />
            </div>
        </div>

        <!-- ③ 商品价格公式 -->
        <div class="ccf-card">
            <div class="ccf-card__head">
                <span class="ccf-badge">3</span>
                <span class="ccf-card__title">商品价格公式</span>
            </div>
            <div class="ccf-card__body">
                <div class="ccf-row ccf-row--formula">
                    <el-checkbox v-model="form.skuAmountCal_check" />
                    <span class="ccf-text">检测：商品价格公式</span>
                    <span class="ccf-text">原价格</span>
                    <span class="ccf-op">×</span>
                    <el-input-number v-model="num" :precision="2" :min="1" :step="0.1"
                        :disabled="!form.skuAmountCal_check" v-model.number="form.coefficient" placeholder="倍数"
                        size="small" />
                    <span class="ccf-text">倍</span>
                    <span class="ccf-op">+</span>
                    <el-input-number v-model="num" :precision="2" :min="1" :step="0.1"
                        :disabled="!form.skuAmountCal_check" v-model.number="form.coefficient_money"
                        placeholder="金额" size="small" />
                    <span class="ccf-text">元</span>
                    <span class="ccf-op">×</span>
                    <el-input-number v-model="num" :precision="2" :step="1" :min="1" :max="10"
                        :disabled="!form.skuAmountCal_check" v-model.number="form.amountDiscount" placeholder="折扣"
                        size="small" />
                    <span class="ccf-text">折<span class="ccf-hint">（{{ (parseFloat(form.amountDiscount) * 0.1).toFixed(2) }}）</span></span>
                </div>
            </div>
        </div>

        <!-- ④ 商品价格违规检测 -->
        <div class="ccf-card">
            <div class="ccf-card__head">
                <span class="ccf-badge">4</span>
                <span class="ccf-card__title">商品价格违规检测</span>
                <el-tooltip content="该功能普通会员使用收费1个链接0.1算力。个人会员，企业会员使用免费，商品SKU超过450个直接进入异常不检测" placement="top">
                    <i class="el-icon-question ccf-tip"></i>
                </el-tooltip>
            </div>
            <div class="ccf-card__body">
                <div class="ccf-row">
                    <el-checkbox v-model="form.skuAmountAbnormal_check" />
                    <span class="ccf-text">检测：商品SKU是否存在价格违规</span>
                </div>
            </div>
        </div>

        <!-- ⑤ 商品价格异常 -->
        <div class="ccf-card">
            <div class="ccf-card__head">
                <span class="ccf-badge">5</span>
                <span class="ccf-card__title">商品价格异常</span>
            </div>
            <div class="ccf-card__body">
                <div class="ccf-row">
                    <span class="ccf-text">检测：以下任一条件触发异常</span>
                </div>
                <div class="ccf-sub">
                    <div class="ccf-subrow" :class="{ 'ccf-subrow--on': form.skuAmountMaxMinGap_check }">
                        <el-checkbox v-model="form.skuAmountMaxMinGap_check" />
                        <span class="ccf-text">检测：商品最高价SKU大于最低价SKU</span>
                        <div class="ccf-subrow__right">
                            <el-input-number v-model="num" :precision="2" :step="0.1"
                                :disabled="!form.skuAmountMaxMinGap_check" v-model.number="form.skuAmountMaxMinGap"
                                placeholder="倍数" size="small" />
                            <span class="ccf-text">倍</span>
                        </div>
                    </div>
                    <div class="ccf-subrow" :class="{ 'ccf-subrow--on': form.skuAmountMaxMinGapMoney_check }">
                        <el-checkbox v-model="form.skuAmountMaxMinGapMoney_check" />
                        <span class="ccf-text">检测：商品最高价SKU超过最低价SKU</span>
                        <div class="ccf-subrow__right">
                            <el-input-number v-model="num" :precision="2" :step="0.1"
                                :disabled="!form.skuAmountMaxMinGapMoney_check"
                                v-model.number="form.skuAmountMaxMinGapMoney" placeholder="输入检测金额" size="small" />
                            <span class="ccf-text">元</span>
                        </div>
                    </div>
                    <div class="ccf-subrow" :class="{ 'ccf-subrow--on': form.skuAmountMaxLimit_check }">
                        <el-checkbox v-model="form.skuAmountMaxLimit_check" />
                        <span class="ccf-text">检测：商品最高价超过</span>
                        <div class="ccf-subrow__right">
                            <el-input-number v-model="num" :precision="2" :step="0.1"
                                :disabled="!form.skuAmountMaxLimit_check" v-model.number="form.skuAmountMaxLimit"
                                placeholder="输入检测金额" size="small" />
                            <span class="ccf-text">元</span>
                        </div>
                    </div>
                    <div class="ccf-subrow" :class="{ 'ccf-subrow--on': form.skuAmountMinLimit_check }">
                        <el-checkbox v-model="form.skuAmountMinLimit_check" />
                        <span class="ccf-text">检测：商品最低价低于</span>
                        <div class="ccf-subrow__right">
                            <el-input-number v-model="num" :precision="2" :step="0.1"
                                :disabled="!form.skuAmountMinLimit_check" v-model.number="form.skuAmountMinLimit"
                                size="small" />
                            <span class="ccf-text">元</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ⑥ 其他设置 -->
        <div class="ccf-card">
            <div class="ccf-card__head">
                <span class="ccf-badge">6</span>
                <span class="ccf-card__title">其他</span>
            </div>
            <div class="ccf-card__body">
                <div class="ccf-row ccf-row--gap">
                    <el-checkbox v-model="form.groupAbnormal" />
                    <span class="ccf-text">检测：选择分组</span>
                    <el-select size="small" :disabled="!form.groupAbnormal" v-model="form.group_ids" class="w220"
                        multiple filterable clearable placeholder="全部" @change="changeGroupIds">
                        <el-option v-for="group in groupList" :key="group.id" :label="group.name"
                            :value="group.id"></el-option>
                    </el-select>
                </div>
                <div class="ccf-row ccf-row--gap">
                    <el-checkbox v-model="form.groupAbnormal" />
                    <span class="ccf-text">检测：选择子分组</span>
                    <el-select size="small" :disabled="!form.groupAbnormal" v-model="form.child_group_id" class="w220"
                        multiple filterable clearable placeholder="全部">
                        <el-option v-for="group in child_groupList" :key="group.id" :label="group.name"
                            :value="group.id"></el-option>
                    </el-select>
                </div>
                <div class="ccf-row ccf-row--gap">
                    <el-checkbox v-model="form.skuReplace_check" />
                    <span class="ccf-text">检测：选择SKU替换</span>
                    <el-select class="w120" :disabled="!form.skuReplace_check" v-model="form.skuReplace" size="small">
                        <el-option label="已替换" :value="1">已替换</el-option>
                        <el-option label="未替换" :value="2">未替换</el-option>
                    </el-select>
                </div>
            </div>
        </div>

        <!-- 操作按钮 -->
        <div class="ccf-actions" v-if="!view_flag">
            <el-button type="success" :loading="btn_loading" plain @click="skudetectionForecast">预估需检测商品数:{{
                this.process_count }}个</el-button>
            <el-button type="warning" v-if="this.process_count > 0" :loading="btn_loading"
                @click="skudetectionSubmit">提交检测</el-button>
            <el-button v-if="this.process_count > 0" plain
                @click="onViewList">检测记录</el-button>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: 'CheckContentForm',
    props: {
        info: {
            type: Object,
            default: () => { } // 默认空对象
        }
    },
    watch: {
        // 监听 info 变化，并且立即执行一次
        info: {
            handler(val) {
                // 第一时间判断是否有值
                this.setinfo(val)
            },
            immediate: true, // 关键：组件一创建就执行
            deep: true        // 如果对象内部属性变化也要监听
        },
        // 监听价格违规检测勾选状态
        'form.skuAmountAbnormal_check': {
            handler(checked) {
                if (checked && this.$store.state.login.user_level == 9) {
                    this.$message.info('该功能普通会员使用收费1个链接0.1算力。个人会员，企业会员使用免费')
                }
            },
            immediate: false
        }
    },
    mounted() {

    },
    created() {
        this.getGroupList()
        if (!this.info) {
            this.getFirstInfo();
        }
    },
    data() {
        return {
            view_flag: false,
            btn_loading: false,
            groupList: [],
            child_groupList: [],
            process_count: 0,
            form: {
                //售价公式
                amountDiscount: 0,
                amountDiscount_type: 2,
                amountDiscount_money: 0,
                //价格公式
                skuAmountCal_check: false,
                coefficient: 0,
                coefficient_type: 1,
                coefficient_money: 0,
                skuReplace_check: false,
                skuReplace: '',
                // 异常SKU名称引流
                skuNameAbnormalWords_check: true,
                skuNameAbnormalWords: '定金，订金，邮费，赠品，换购，试用，样品，瑕疵品，二手，模型，缺货，联系客服，下单不发货，不建议拍下，运费，定金，订金，补差，差价，不发货，勿拍，不要拍，专拍，改价，备注，注意事项，试用，试吃，小样，样品，一片，1片， 一张，1张，一瓶，1瓶',
                skuSizeAbnormalWords_check: true,
                skuSizeAbnormalWords: 'XXXXXXXXXS，XXXXXXXXS，XXXXXXXS，XXXXXXS，XXXXXS，XXXXS，XXXS，XXS，XS，58码',
                // 套装/零配件拆卖
                suitSplitSell: false,
                suitSplitKeywords: '',
                // 异常运费
                abnormalFreight: false,
                abnormalFreightAmount: null,
                virtualProductFreight: true,
                // 商品价格异常
                skuAmountMaxMinGap_check: false,
                skuAmountAbnormal_check: true,
                skuAmountMaxMinGap: null,
                skuAmountMaxMinGapMoney_check: false,
                skuAmountMaxMinGapMoney: null,
                skuAmountMaxLimit_check: false,
                skuAmountMaxLimit: null,
                skuAmountMinLimit_check: false,
                skuAmountMinLimit: null,
                // SKU低价规格深度检测
                skuSpecAbnormal: true,
                groupAbnormal: false,
                group_ids: '',
                child_group_id: '',
                group_names: '',
            },
            skuNameInput: ''
        }
    },
    methods: {
        ...mapActions({
            getCloudProductGroups: 'ucenter/getCloudProductGroups',
            opSkudetectionSubmit: 'ucenter/opSkudetectionSubmit',
            opskudetectionForecast: 'ucenter/opskudetectionForecast',
            opGetSkudetectionPage: 'ucenter/opGetSkudetectionPage',
        }),
        // 获取分组列表
        getGroupList() {
            this.getCloudProductGroups({
                data: { with_count: 0 },
                success: (res) => {
                    if (res.code === 200) {
                        this.groupList = res.data || []
                        if (this.groupList.length > 0) {
                            const tem_child_group_id = this.form.child_group_id
                            if (tem_child_group_id) {
                                this.changeGroupIds(this.form.group_ids);
                                this.form.child_group_id = tem_child_group_id
                            }
                        }
                    }
                }
            })
        },
        setinfo(val) {
            if (val && Object.keys(val).length > 0) {
                this.view_flag = true
                // 初始化数据
                if (val.sku_name_abnormal_words) {
                    this.form.skuNameAbnormalWords_check = true
                    this.form.skuNameAbnormalWords = val.sku_name_abnormal_words
                } else {
                    this.form.skuNameAbnormalWords_check = false
                    this.form.skuNameAbnormalWords = ''
                }
                // 初始化数据
                if (val.sku_size_abnormal_words) {
                    this.form.skuSizeAbnormalWords_check = true
                    this.form.skuSizeAbnormalWords = val.sku_size_abnormal_words
                } else {
                    this.form.skuSizeAbnormalWords_check = false
                    this.form.skuSizeAbnormalWords = ''
                }

                if (val.coefficient) {
                    this.form.skuAmountCal_check = true
                    this.form.coefficient = val.coefficient
                    this.form.coefficient_type = val.coefficient_type

                    this.form.amountDiscount = val.amount_discount
                    if (val.coefficient_money) {
                        this.form.coefficient_money = val.coefficient_money
                    }
                    if (val.amount_discount_money) {
                        this.form.amountDiscount_money = val.amount_discount_money
                    }
                } else {
                    this.form.coefficient = 0
                    this.form.coefficient_type = 1
                    this.form.amountDiscount = 0
                    this.form.coefficient_money = 0
                    this.form.skuAmountCal_check = false
                }

                if (val.sku_amount_max_min_gap) {
                    this.form.skuAmountMaxMinGap_check = true
                    this.form.skuAmountMaxMinGap = val.sku_amount_max_min_gap
                } else {
                    this.form.skuAmountMaxMinGap_check = false
                    this.form.skuAmountMaxMinGap = 0
                }
                if (val.sku_amount_max_min_gap) {
                    this.form.skuAmountAbnormal_check = true
                } else {
                    this.form.skuAmountAbnormal_check = false
                }

                if (val.sku_amount_max_min_gapmoney) {
                    this.form.skuAmountMaxMinGapMoney_check = true
                    this.form.skuAmountMaxMinGapMoney = val.sku_amount_max_min_gapmoney
                } else {
                    this.form.skuAmountMaxMinGapMoney_check = false
                    this.form.skuAmountMaxMinGapMoney = 0
                }

                if (val.sku_amount_max_limit) {
                    this.form.skuAmountMaxLimit_check = true
                    this.form.skuAmountMaxLimit = val.sku_amount_max_limit
                } else {
                    this.form.skuAmountMaxLimit_check = false
                    this.form.skuAmountMaxLimit = 0
                }

                if (val.sku_amount_min_limit) {
                    this.form.skuAmountMinLimit_check = true
                    this.form.skuAmountMinLimit = val.sku_amount_min_limit
                } else {
                    this.form.skuAmountMinLimit_check = false
                    this.form.skuAmountMinLimit = 0
                }
                if (val.group_ids) {
                    this.form.groupAbnormal = true
                    this.form.group_ids = val.group_ids.split(',').map(item => parseInt(item));
                    this.changeGroupIds(this.form.group_ids);
                    if (val.child_group_id) {
                        this.form.child_group_id = val.child_group_id
                    }
                } else {
                    this.form.groupAbnormal = false
                    this.form.group_ids = ''
                    this.form.child_group_id = []
                }
                if (val.sku_is_replace && val.sku_is_replace <= 2) {
                    this.form.skuReplace_check = true
                    this.form.skuReplace = val.sku_is_replace
                } else {
                    this.form.skuReplace_check = false
                    this.form.skuReplace = ''
                }
            } else {
                this.view_flag = false
            }
        },
        //获取检测列表
        getFirstInfo() {
            let param = { page_size: 1, page: 1 }
            this.opGetSkudetectionPage({
                data: param,
                success: (res) => {
                    if (res.code == 200) {
                        const firstItem = res.data.list?.[0];
                        if (firstItem) {
                            // 处理第一条数据
                            this.setinfo(firstItem);
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                    this.view_flag = false
                }
            })
        },
        //提交sku低价检测
        skudetectionSubmit() {
            this.btn_loading = true
            if (this.form.skuAmountCal_check && (this.form.coefficient <= 0 || this.form.amountDiscount <= 0)) {
                this.$message.error('原价格和销售价格倍数必须大于0')
                this.btn_loading = false
                return
            }

            if (this.form.skuNameAbnormalWords_check) {
                if (this.form.skuNameAbnormalWords.includes(',')) {
                    this.$message.error('英文逗号不是分隔符');
                    this.btn_loading = false
                    return
                }
            }

            if (this.groupList) {
                this.form.group_names = this.groupList.filter(i => this.form.group_ids.includes(i.id)).map(i => i.name)
            }

            // 只有勾选了价格违规检测才需要扣费
            if (this.form.skuAmountAbnormal_check) {
                const userLevel = this.$store.state.login.user_level

                if (userLevel == 9) {
                    // 普通会员需要算力
                    const userinfo = this.$store.state.login.userinfo
                    const requiredPower = this.process_count * 0.1
                    const currentPower = userinfo.conventional_computing_power || 0

                    if (currentPower < requiredPower) {
                        this.$confirm(
                            `该功能需消耗 ${requiredPower.toFixed(1)} 算力，当前算力余额不足（剩余：${currentPower}），是否前往充值？`,
                            '算力不足',
                            {
                                confirmButtonText: '去充值',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }
                        ).then(() => {
                            this.$router.push('/new_finance_workbench?menu=wallet')
                        }).catch(() => {})
                        this.btn_loading = false
                        return
                    }

                    this.$confirm(
                        `该功能将消耗 ${requiredPower.toFixed(1)} 算力，是否继续？`,
                        '确认提交',
                        {
                            confirmButtonText: '确认提交',
                            cancelButtonText: '取消',
                            type: 'info'
                        }
                    ).then(() => {
                        this.doSubmit()
                    }).catch(() => {
                        this.btn_loading = false
                    })
                } else {
                    // 企业会员/个人会员免费
                    this.doSubmit()
                }
            } else {
                // 未勾选价格违规检测，直接提交
                this.doSubmit()
            }
        },
        // 提取原有提交逻辑为独立方法
        doSubmit() {
            this.opSkudetectionSubmit({
                data: this.form,
                success: (res) => {
                    this.btn_loading = false
                    if (res.code === 200) {
                        this.$message.success('检测任务已生成，检测编号：' + res.data.task_no)
                        this.$emit('submitted', res.data.task_no)
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        //预估商品数量
        skudetectionForecast() {
            this.btn_loading = true
            if (this.form.skuAmountCal_check && (this.form.coefficient <= 0 || this.form.amountDiscount <= 0)) {
                this.$message.error('原价格和销售价格倍数必须大于0')
                this.btn_loading = false
                return
            }

            if (this.form.skuNameAbnormalWords_check) {
                if (this.form.skuNameAbnormalWords.includes(',')) {
                    this.$message.error('英文逗号不是分隔符');
                    this.btn_loading = false
                    return
                }
            }

            if (this.groupList) {
                this.form.group_names = this.groupList.filter(i => this.form.group_ids.includes(i.id)).map(i => i.name)
            }

            // 只传递预估需要的参数
            const forecastParams = {
                group_ids: this.form.group_ids,
                child_group_id: this.form.child_group_id,
                groupAbnormal: this.form.groupAbnormal,
                skuReplace_check: this.form.skuReplace_check,
                skuReplace: this.form.skuReplace
            }

            this.opskudetectionForecast({
                data: forecastParams,
                success: (res) => {
                    this.btn_loading = false
                    if (res.code === 200) {
                        this.process_count = res.data.process_count

                        let message = `预估商品数：${this.process_count}个`

                        if (this.form.skuAmountAbnormal_check) {
                            const userLevel = this.$store.state.login.user_level
                            if (userLevel == 9) {
                                const requiredPower = this.process_count * 0.1
                                message += `，将消耗 ${requiredPower.toFixed(1)} 算力`
                            } else {
                                message += `（企业版会员免费）`
                            }
                        }

                        this.$message.success(message)
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        // 添加SKU名称标签
        addSkuNameTag() {
            if (this.skuNameInput && !this.form.skuNameKeywords.includes(this.skuNameInput)) {
                this.form.skuNameKeywords.push(this.skuNameInput)
                this.skuNameInput = ''
            }
        },
        // 移除SKU名称标签
        removeSkuNameTag(tag) {
            const index = this.form.skuNameKeywords.indexOf(tag)
            if (index > -1) {
                this.form.skuNameKeywords.splice(index, 1)
            }
        },
        changeGroupIds(val) {
            this.$set(this.form, 'child_group_id', [])
            this.child_groupList = this.groupList.filter(i => val.includes(i.id)).map(i => i.child_groups || []).flat()
        },
        // 查看检测记录
        onViewList() {
            this.$emit('view-list')
        },
    }
}
</script>

<style scoped>
.check-content-form {
    /* 两列网格：①｜②、③｜④、⑤｜⑥，操作栏跨两列；一屏放完 */
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    align-items: stretch;
}

/* ══ 卡片分区 ══ */
.ccf-card {
    background: #FFFFFF;
    margin-bottom: 0;
    overflow: hidden;
    border-radius: 8px;
    border: 2px solid rgb(224, 224, 236);
    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
    min-width: 0;
    display: flex;
    flex-direction: column;
}
.ccf-card__head {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 36px;
    padding: 0 14px;
    background: #F6EFE2;
    font-size: 14px;
    color: #3A3A4A;
    flex-shrink: 0;
}
.ccf-card__title {
    font-weight: 600;
}
.ccf-badge {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #E6463D;
    color: #FFFFFF;
    font-size: 12px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.ccf-tip {
    color: #909399;
    cursor: pointer;
    font-size: 14px;
}
.ccf-card__body {
    padding: 10px 14px;
    flex: 1;
}

/* ══ 行内元素 ══ */
.ccf-row {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    font-size: 13px;
    color: #4A4A6A;
}
.ccf-row--gap {
    margin-bottom: 9px;
}
.ccf-row--gap:last-child {
    margin-bottom: 0;
}
.ccf-row--formula {
    gap: 7px;
}
.ccf-text {
    color: #4A4A6A;
    font-size: 13px;
    white-space: nowrap;
}
.ccf-op {
    color: #909399;
    font-size: 13px;
}
.ccf-hint {
    color: #909399;
    margin-left: 4px;
}
.ccf-textarea {
    margin-top: 8px;
}

/* ══ 价格异常子行 ══ */
.ccf-sub {
    margin-top: 9px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.ccf-subrow {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #FAF6EC;
    border: 1px solid transparent;
    border-radius: 8px;
    padding: 6px 12px;
}
.ccf-subrow--on {
    background: #FBF7EC;
    border-color: #E8C778;
}
.ccf-subrow__right {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 6px;
}

/* ══ 底部按钮（跨两列） ══ */
.ccf-actions {
    grid-column: 1 / -1;
    margin-top: 0;
    background: rgb(255, 255, 255);
    border-radius: 8px;
    border: 2px solid rgb(224, 224, 236);
    padding: 9px 16px;
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
}

/* ══ 查看策略弹窗（宽 50%）内同样一行两个，并进一步紧凑 ══ */
.rc-dialog .check-content-form {
    gap: 10px;
}
.rc-dialog .ccf-card__head {
    height: 32px;
    padding: 0 12px;
    font-size: 13px;
}
.rc-dialog .ccf-card__body {
    padding: 9px 12px;
}
.rc-dialog .ccf-subrow {
    padding: 5px 10px;
}
.rc-dialog .ccf-actions {
    padding: 8px 12px;
}

/* ══ 窄屏回退单列 ══ */
@media (max-width: 1200px) {
    .check-content-form {
        grid-template-columns: 1fr;
    }
}

.w220 {
    width: 220px;
}
.w120 {
    width: 120px;
}

/* ══ Element 组件微调 ══ */
:deep(.el-checkbox__inner) {
    margin-right: 5px;
    border-radius: 3px;
}
:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background: #D4A946;
    border-color: #D4A946;
}
:deep(.el-checkbox__input.is-focus .el-checkbox__inner) {
    border-color: #D4A946;
}
:deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
    color: #D4A946;
}
:deep(.el-input-number) {
    width: 120px;
}
:deep(.el-input-number .el-input__inner) {
    color: #E6463D;
    font-weight: 600;
}
:deep(.el-input-number.is-disabled .el-input__inner) {
    color: #C0C4CC;
}
:deep(.ccf-textarea .el-textarea__inner) {
    border-radius: 6px;
    border-color: #DCDFE6;
    font-size: 13px;
}
</style>
